import PropTypes from "prop-types";
import React from "react";
import Heading from "../../elements/heading";
import PrimaryButton from "../../elements/primary-button";
import "./style.scss";
import BodyText from "../../elements/body-text";
const CheckoutGuest = props => {
  console.log("props", props);
  const { headingType, headingBody, description, button, onContinue } = props;
  const { ctaType, link, colorScheme, iconName } = button.fields;
  const buttonProps = {
    ctaType,
    buttonText: link.value.text,
    colorScheme,
    iconName,
    callback: evt => onContinue(evt)
  };
  return (
    <form className="checkout-guest-form">
      {headingBody && (
        <Heading
          type={headingType}
          className="title show-on-scroll type-h3"
          html={headingBody}
        />
      )}
      <BodyText html={description.value} className="description" />
      <div className="button-container">
        {link.value.text && <PrimaryButton {...buttonProps} />}
      </div>
    </form>
  );
};

CheckoutGuest.propTypes = {
  heading: PropTypes.object,
  description: PropTypes.object,
  submitButton: PropTypes.object
};

CheckoutGuest.defaultProps = {
  submitGuest: () => {}
};

export default CheckoutGuest;
